<div class="logged-in-root">
    <span class="login-msg">
        You are logged in as <span class="username"></span>.<br>
        Welcome back!
    </span>
    <button id="btn-logout">Log out</button>
</div>